const systemsConfig = [
    { name: 'EPILOG', websocketKeys: ['EPILOG'] },
    { name: 'WTG', websocketKeys: ['PI'] },
    { name: 'EDL', websocketKeys: ['GRID', 'GRID_FORECAST'] },
];

export const getErroredSystems = (parkSystems) => {
    const visibleSystems = systemsConfig.filter((systemConfig) =>
        parkSystems.find((system) => systemConfig.websocketKeys.includes(system.key) && system.status !== 'Operational')
    );

    return visibleSystems;
};
